import Chart from 'chart.js/auto';

let charts = {
    charts: {},
    init: function () {
        charts.load();
    },

    load:function() {
        let charts = [];

        document.querySelectorAll('.chart').forEach(chart => {
            let alert  = chart.parentNode.querySelector('.alert');
            let target = chart.dataset.class;

            if (alert) {
                alert.remove();
            }

            if (chart.dataset.id) {
                target += ':' + chart.dataset.id;
            }

            charts.push(target);
        });

        if (charts.length) {
            window.JellyBelly.stream(
                'charts/get',
                {
                    charts: charts
                },
                json => {
                    let query = '.chart[data-class="' + json.class + '"]';

                    if (json.id !== false) {
                        query += '[data-id="' + json.id + '"]';
                    }

                    if (json.chartjs) {
                        if (Object.keys(json.prefixes).length || Object.keys(json.suffixes).length) {
                            if (json.chartjs.options.plugins.tooltip.callbacks === null) {
                                json.chartjs.options.plugins.tooltip.callbacks = {};
                            }

                            json.chartjs.options.plugins.tooltip.callbacks.label = context => {
                                let label = ' ';

                                if (context.parsed.y !== null) {
                                    if (Object.keys(json.prefixes).length && json.prefixes[context.dataset.label]) {
                                        label += json.prefixes[context.dataset.label];
                                    }

                                    label += context.parsed.y;

                                    if (Object.keys(json.suffixes).length && json.suffixes[context.dataset.label]) {
                                        label += json.suffixes[context.dataset.label];
                                    }
                                }

                                return label;
                            };
                        }

                        document.querySelectorAll(query).forEach(canvas => {
                            let identifier = json.class + '-' + json.id;

                            if (json.styles) {
                                Object.keys(json.styles).forEach(key => {
                                    canvas.parentNode.style[key] = json.styles[key];
                                });
                            }

                            if (window.JellyBelly.charts.charts[identifier]) {
                                window.JellyBelly.charts.charts[identifier].destroy();
                            }

                            window.JellyBelly.charts.charts[identifier] = new Chart(
                                canvas,
                                json.chartjs
                            );
                        });
                    } else {
                        document.querySelectorAll(query).forEach(canvas => {
                            if (window.JellyBelly.charts.charts[json.id]) {
                                window.JellyBelly.charts.charts[json.id].destroy();
                            }

                            canvas.parentNode.innerHTML += json.data;
                        });
                    }
                }
            );
        }
    }
};

export default charts;
